<app-details-loader *ngIf="loadFlag || errorMsg" [errorMsg]="errorMsg" [Height]="'70vh'" [LoaderMarginTop]="'19%'" ></app-details-loader>
<payarc-back-link label="Back to webhook logs" route="/events-and-logs/webhooks" *ngIf="!loadFlag && !errorMsg"></payarc-back-link>
<div  class="row" *ngIf="!loadFlag && !errorMsg">
  <div  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
    <h3  class="headings">WebHook Logs</h3>
  </div>
</div>
<div class="event-bdy">
  <div class="row">
    <div class="col-sm-12 col-md-12 col-xl-12 col-lg-12 col-12 pt-m-16">
      <h4 class="head-text" >{{!webhookData.event_type ? '----' : (webhookData.event_type | camalizeStr : true).replace('usd', "USD") }}</h4>
    </div>
  </div>
  <div class="clearfix">
    <div class="b_shadow">
      <div class="heading-card col-sm-12 col-md-12 col-xl-12 col-lg-12 col-12">
        <div class="row m-0">
          <div class="col-sm-6 col-md-6 col-xl-6 col-lg-6 col-6 left-heading pl-4">
            <span>Webhook Log Details</span>
          </div>
        </div>
      </div>
      <div class="pl-sm-4 pl-2 mt-sm-0 mt-2 col-sm-12 col-md-12 col-xl-12 col-lg-12 col-12">
        <div class="row py-sm-2 py-0 inner-details-subsc">
          <div class="col-lg-2 col-md-4 col-xl-2 col-sm-4 col-5 left-heading">
            ID:
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xl-8 col-7 right-data">
            <span>{{!webhookData.id ? '----' : webhookData.id}}</span>
          </div>
        </div>
        <div class="row py-sm-2 py-0 inner-details-subsc">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xl-2 col-5 left-heading">Created:</div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xl-8 col-7 right-data">
            <span>{{!webhookData.created_at ?  '----' : webhookData.created_at | dateFormat: 'MM/dd/yyyy hh:mm'}}</span>
          </div>
        </div>
        <div class="row py-sm-2 py-0 inner-details-subsc">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xl-2 col-5 left-heading">
            Type:
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xl-8 col-7 right-data">
            <span>{{!webhookData.event_type ? '----' : webhookData.event_type}} </span>
          </div>
        </div>
        <div class="row py-sm-2 py-0 inner-details-subsc">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xl-2 col-5 left-heading">
            Status:
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xl-8 col-7 right-data">
            <span>{{!webhookData.status ? '----' : webhookData.status}} </span>
          </div>
        </div>
        <div class="row py-sm-2 py-0 inner-details-subsc">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xl-2 col-5 left-heading">
            Response Status Code:
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xl-8 col-7 right-data">
            <span>{{!webhookData.response_status_code ? '----' : webhookData.response_status_code}} </span>
          </div>
        </div>
        <div class="row py-sm-2 py-0 inner-details-subsc">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xl-2 col-5 left-heading">
            Event Id:
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xl-8 col-7 right-data">
            <span>{{!webhookData.event_id ? '----' : webhookData.event_id}} </span>
          </div>
        </div>
        <div class="row py-sm-2 py-0 inner-details-subsc">
          <div class="col-lg-2 col-md-4 col-sm-4 col-xl-2 col-5 left-heading">
            Url:
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xl-8 col-7 right-data">
            <a [href]="webhookData.url" target="_blank" rel="noopener noreferrer">{{ webhookData.url }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="b_shadow mt-4">
    <div class="heading-card col-lg-12 col-md-12 col-sm-12 col-xl-12 col-12">
      <div class="row m-0">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xl-6 col-6 left-heading pl-4">
          <span>Webhook Log data (json)</span>
        </div>

      </div>
    </div>

    <div class="pl-4 mt-0 col-lg-12 col-md-12 col-sm-12 col-xl-12 col-12">
      <ng-container *ngIf="webhookData; else noData">
        <ngx-json-viewer [json]="webhookData" [expanded]="false"></ngx-json-viewer>
      </ng-container>
      <ng-template #noData>
        <p>No Details Available!</p>
      </ng-template>
    </div>

  </div>
</div>
